import { createContext, useContext } from 'react';

import { useCustomerDetails } from './hook';

type CustomerDetailsContext = ReturnType<typeof useCustomerDetails>;

export const CustomerDetailsContext =
    createContext<CustomerDetailsContext | null>(null);

export const CustomerDetailsProvider = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const customerDetails = useCustomerDetails();

    return (
        <CustomerDetailsContext.Provider value={customerDetails}>
            {children}
        </CustomerDetailsContext.Provider>
    );
};

export const useCustomerDetailsContext = () => {
    const context = useContext(CustomerDetailsContext);
    if (!context) {
        throw new Error(
            'useCustomerDetailsContext must be used within a CustomerDetailsProvider',
        );
    }
    return context;
};
